import { MetadataFlagTypes } from '../enums/MetadataFlagTypes';
import { StatusEnum } from '../enums/StatusEnum';
import colorPalette from '../themes/colorPalette';

const { blue, coolGrey, green } = colorPalette;

type StatusEnumRequiments = Record<
  number,
  {
    circleColor: string;
    pathColor: string;
  }
>;

type MetadataFlagRequirements = Record<MetadataFlagTypes, StatusEnumRequiments>;

const metadataFlagColors: MetadataFlagRequirements = {
  [MetadataFlagTypes.Standard]: {
    [StatusEnum.Passed]: {
      circleColor: green[4],
      pathColor: '#0F3314',
    },
    [StatusEnum.Failed]: {
      circleColor: '#FFACAC',
      pathColor: '#870300',
    },
    [StatusEnum.Unknown]: {
      circleColor: blue[2],
      pathColor: blue[8],
    },
  },

  [MetadataFlagTypes.Neutral]: {
    [StatusEnum.Passed]: {
      circleColor: coolGrey[3],
      pathColor: coolGrey[9],
    },
    [StatusEnum.Failed]: {
      circleColor: coolGrey[3],
      pathColor: coolGrey[9],
    },
    [StatusEnum.Unknown]: {
      circleColor: coolGrey[3],
      pathColor: coolGrey[9],
    },
  },
};

export default function useGetMetadataFlagColors(
  statusEnum: StatusEnum,
  metadataFlagType: MetadataFlagTypes
): any {
  if (!metadataFlagColors[metadataFlagType])
    throw Error('Invalid metadata flag type');
  if (!metadataFlagColors[metadataFlagType][statusEnum])
    throw Error('Invalid metadata status');
  return metadataFlagColors[metadataFlagType][statusEnum];
}
